// extracted by mini-css-extract-plugin
module.exports = {"footer-nav":"footer_footer-nav___7wTs","footer-nav-link":"footer_footer-nav-link__M3j9W"};